import React from 'react';
import { justiceSphereLabel } from '../../utils/justiceSphere';

export default function JusticeIcon({ type, showLabel = false }) {
  const configs = {
    comum: {
      icon: '⚖️',
      label: justiceSphereLabel('comum', 'shortLabel'),
      color: 'bg-gray-100 text-gray-800'
    },
    federal: {
      icon: '🏛️',
      label: justiceSphereLabel('federal', 'shortLabel'),
      color: 'bg-blue-100 text-blue-800'
    },
    trabalho: {
      icon: '👷',
      label: justiceSphereLabel('trabalho', 'shortLabel'),
      color: 'bg-orange-100 text-orange-800'
    }
  };

  const config = configs[type?.toLowerCase()] || {
    icon: '⚖️',
    label: type || 'N/A',
    color: 'bg-gray-100 text-gray-800'
  };

  if (showLabel) {
    return (
      <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${config.color}`}>
        <span className="mr-1">{config.icon}</span>
        {config.label}
      </span>
    );
  }

  return (
    <span className="text-lg" title={config.label}>
      {config.icon}
    </span>
  );
}
